import { useEffect, ReactNode } from 'react'
import { useAuth } from '@/hooks/use-auth'

interface AuthProviderProps {
  children: ReactNode
}

export function AuthProvider({ children }: AuthProviderProps) {
  const { checkSession } = useAuth()

  useEffect(() => {
    // Check session on app load
    checkSession()
  }, [checkSession])

  return <>{children}</>
}
